// src/components/charts/AuditsPerMonthChart.tsx
import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Audit } from '../../types';

type ApexOptions = any;

interface AuditsPerMonthChartProps {
  audits: Audit[];
}

const AuditsPerMonthChart: React.FC<AuditsPerMonthChartProps> = ({ audits }) => {
  // Agrupar auditorías por mes
  const auditsByMonth = audits.reduce((acc, audit) => {
    const date = new Date(audit.createdAt);
    const monthYear = `${date.toLocaleString('es-ES', { month: 'short' })} ${date.getFullYear()}`;
    acc[monthYear] = (acc[monthYear] || 0) + 1;
    return acc;
  }, {} as Record<string, number>);

  const categories = Object.keys(auditsByMonth);
  const data = Object.values(auditsByMonth);

  const options: ApexOptions = {
    chart: {
      type: 'bar',
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '60%',
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: categories,
      labels: {
        style: {
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      title: {
        text: 'Número de Auditorías',
      },
    },
    colors: ['#1890ff'],
    title: {
      text: 'Auditorías por Mes',
      align: 'left',
      style: {
        fontSize: '16px',
        fontWeight: 600,
      },
    },
    tooltip: {
      y: {
        formatter: (val: number) => `${val} auditoría${val !== 1 ? 's' : ''}`,
      },
    },
  };

  const series = [
    {
      name: 'Auditorías',
      data: data,
    },
  ];

  return <ReactApexChart options={options} series={series} type="bar" height={300} />;
};

export default AuditsPerMonthChart;
